<app-preloader></app-preloader>
<ng-container *ngIf="location?.startsWith('/admin'); else customerNavigation">
    <div class="app-shell">
        <app-admin-navbar></app-admin-navbar>
        <ng-container *ngIf="isAdminShow">
            <app-custom-navbar></app-custom-navbar>
        </ng-container>
        <main class="app-main">
            <router-outlet></router-outlet>
        </main>
        <ng-container *ngIf="isShowFooter">
            <app-footer *ngIf="!(location === '/coming-soon')"></app-footer>
        </ng-container>
    </div>
</ng-container>

<ng-template #customerNavigation>
    <div class="app-shell">
        <app-navbar *ngIf="!(location === '/coming-soon')"></app-navbar>
        <ng-container *ngIf="isShow">
            <app-custom-navbar></app-custom-navbar>
        </ng-container>
        <main class="app-main">
            <router-outlet></router-outlet>
        </main>
        <ng-container *ngIf="isShowFooter">
            <app-footer *ngIf="!(location === '/coming-soon')"></app-footer>
        </ng-container>
    </div>
</ng-template>
